import "@lottiefiles/lottie-player";

export default class Block01 {
    constructor (query) {
        const el = document.querySelector(query);
        if (!el) return;

        const lottie = el.querySelector(`${query}__media--lottie lottie-player`);
        if (!lottie) return;

        this.el = el;
        this.lottie = lottie;

        this.init();
    }

    init () {
        this.lottie.addEventListener('play', (event) => {
            const svg = event.target.shadowRoot.querySelector('svg');

            if (svg) svg.style.transform = '';
        });

        this.lottie.play();
    }
}
